import React from "react";
import './AiWarning.css'

const AiWarning = () => 
    <div className='ai-warning-message'>
        AI-generated content can be inaccurate. Make sure to review it before using it.
    </div>;

export default AiWarning;